<template>
  <div class="wrap">
    <div class="container">
      <div class="info_box">
        <el-image
          v-if="classInfo.courseImage"
          class="cover"
          :src="classInfo.courseImage"
          fit="cover"
        ></el-image>
        <div class="right">
          <div>
            <p class="course_title">{{ classInfo.courseTitle }}</p>
            <p class="course_class">{{ classInfo.name }}</p>
          </div>
          <p class="desc">{{ classInfo.courseInfo }}</p>

          <div class="tabs">
            <div
              class="tab"
              :class="{ activeTab: item.id == activeId, hide: !item.show }"
              v-for="item in tabList"
              :key="item.id"
              @click="changeTab(item.id, item.path)"
            >
              <p class="tab_label">{{ item.topLabel || item.label }}</p>
              <p class="big" v-if="item.bottomLabel">
                {{ item.bottomLabel }}
              </p>
              <p class="big" v-else>
                {{ classInfo[item.text] || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="main">
        <keep-alive include="chapters">
          <router-view
            :classInfo="classInfo"
            :permissions="permissions"
            :showUpData="showUpData"
            :showEnter="showEnter"
          ></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { assistantPermission } from "@/api/assistantMode";
import { classInfo } from "@/api/assistantMode/class";
export default {
  name: "assistantMode",
  data() {
    return {
      classInfo: {},
      activeId: 1,
      tabList: [
        {
          id: 1,
          label: "章节",
          text: "chapterCount",
          path: "/assistantMode/chapters",
          show: true,
        },
        {
          id: 6,
          topLabel: "作品",
          bottomLabel: "圈",
          path: "/assistantMode/works",
          show: false,
        },
        {
          id: 7,
          topLabel: "题",
          bottomLabel: "库",
          path: "/assistantMode/questionBank",
          childrenPath: ["/assistantMode/questionBank/detail"],
          show: false,
        },
        {
          id: 8,
          topLabel: "考",
          bottomLabel: "试",
          path: "/assistantMode/exam",
          show: false,
        },
      ],
      permissions: [],
      showUpData: false,
      showEnter: false,
    };
  },
  created() {
    localStorage.setItem("classId", this.$route.query.id);
    this.getAssistantPermission();
    this.getClassInfo();
    this.setActiveId();
  },
  computed: {
    update() {
      return this.$store.state.update;
    },
  },
  watch: {
    $route() {
      this.setActiveId();
    },
    update(val) {
      if (val) {
        this.getClassInfo();
        this.$store.commit("SET_UPDATE", false);
      }
    },
  },
  methods: {
    // 助教权限
    getAssistantPermission() {
      assistantPermission(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.permissions = res.data;
          this.showEnter = this.permissions.some((item) => {
            return (
              item == "ANNEX" ||
              item == "TASK" ||
              item == "WORKS" ||
              item == "ACTIVITY" ||
              item == "QUALITY"
            );
          });
          let worksTab = this.tabList.find((item) => {
            return item.id == 6;
          });
          worksTab.show = this.permissions.some((p) => {
            return p == "WORKS";
          });

          let questionsTab = this.tabList.find((item) => {
            return item.id == 7;
          });
          questionsTab.show = this.permissions.some((p) => {
            return p == "QUESTION";
          });

          let examTab = this.tabList.find((item) => {
            return item.id == 8;
          });
          examTab.show = this.permissions.some((p) => {
            return p == "EXAM";
          });

          this.showUpData = this.permissions.some((p) => {
            return p == "ANNEX";
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级信息
    getClassInfo() {
      // this.$loading.show();
      classInfo(this.$route.query.id).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    setActiveId() {
      let activeTab = this.tabList.find((item) => {
        return item.path == this.$route.path;
      });
      if (!activeTab) {
        this.tabList.forEach((item) => {
          if (item.childrenPath) {
            if (this.$route.path.indexOf(item.path) != -1) activeTab = item;
          }
        });
      }
      this.activeId = activeTab.id;
    },
    changeTab(id, path) {
      if (id == 8) {
        this.$message.warning("暂未开放");
        return;
      }
      this.activeId = id;
      this.$router.push({
        path,
        query: {
          id: this.$route.query.id,
          courseId: this.$route.query.courseId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(248, 248, 248);

  .info_box {
    width: 100%;

    .cover {
      display: inline-block;
      width: 360px;
      height: 240px;
      vertical-align: top;
    }

    .right {
      position: relative;
      display: inline-block;
      padding: 26px 40px;
      width: calc(100% - 360px);
      height: 240px;
      text-align: left;
      color: #fff;
      background: linear-gradient(180deg, #1976f5, #bd4593 100%);

      .course_title,
      .course_class {
        display: inline-block;
        margin-right: 20px;
        color: #fff;
        font-weight: bold;
        font-size: 24px;
        &.course_class {
          font-size: 20px;
        }
      }

      .desc {
        margin-top: 10px;
        max-height: 65px;
        font-size: 16px;
        text-indent: 2em;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
      }

      .tabs {
        position: absolute;
        left: 40px;
        bottom: -20px;

        .tab {
          display: inline-block;
          padding-top: 22px;
          margin-right: 7px;
          width: 79px;
          height: 100px;
          // line-height: 100px;
          text-align: center;
          color: #fff;
          border-radius: 10px;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          vertical-align: bottom;
          transition: all 0.5s ease;
          cursor: pointer;

          &.activeTab {
            height: 120px;
          }

          &.hide {
            display: none;
          }

          &:first-child {
            background: #1890ff;
          }

          &:nth-child(2) {
            background: #e6028d;
          }

          &:nth-child(3) {
            background: #6ce115;
          }

          &:nth-child(4) {
            background: #00c636;
          }

          p {
            font-size: 16px;
            height: 20px;

            &.tab_label {
              margin-bottom: 8px;
            }

            &.big {
              font-size: 24px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  .main {
    margin: 30px 0;
  }
}
</style>